import LxcError from "~/core/models/LxcError.class";
import type { UseUserActionParameters } from "~/modules/user/models/UseUserActionParameters.interface";
import type { User } from "~/modules/user/models/User.interface";
import userAdministrationService from "~/modules/user/services/userAdministration.service";

export function useDeactivateUser({
  businessUnitCode,
  organizationCode,
}: UseUserActionParameters) {
  const isLoading: Ref<boolean | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();

  async function deactivateUser(userLogin: string): Promise<void> {
    isLoading.value = true;
    error.value = undefined;
    let response: User;

    if (businessUnitCode) {
      response = await userAdministrationService.deactivateBusinessUnitUser(
        businessUnitCode,
        userLogin,
      );
    } else if (organizationCode) {
      response = await userAdministrationService.deactivateOrganizationUser(
        organizationCode,
        userLogin,
      );
    } else {
      response =
        await userAdministrationService.deactivateSuperAdministrationUser(
          userLogin,
        );
    }

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    deactivateUser,
  };
}
